import {GUIDES_INDEX_CONTENT, HOME_INVENTORY_GUIDE_CONTENT} from './guides-content';
import {GUIDE_SEO_CONTENT} from './guide-seo-content';
import type {AppLanguageCode} from '../shared/i18n/app-language';

export const PUBLIC_GUIDE_METADATA: Record<string, Record<AppLanguageCode, {metaTitle: string; metaDescription: string}>> = {
  '/guides': GUIDES_INDEX_CONTENT,
  '/guides/home-inventory': HOME_INVENTORY_GUIDE_CONTENT,
};

for (const [slug, metadata] of Object.entries(GUIDE_SEO_CONTENT)) {
  PUBLIC_GUIDE_METADATA[`/guides/${slug}`] = metadata;
}
